module.exports = __webpack_public_path__ + "assets/img/IPIcon.30d215a8.svg";